import React from "react"
import ReactDOM from "react-dom"
import TopmenuUsp from "./TopmenuUsp"

export default class TopmenuUspModule {
  constructor(elem) {
    this.elem = elem
    this.elem.usp = JSON.parse(elem.dataset.usp || "")
    this.init()
    return this
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(<TopmenuUsp usp={this.elem.usp} />, this.elem)
  }
}
